import React from 'react'
import './Pages.css'
import '../App.css'

const Loading = () => {
    return (
        <div id="preloader">
            <div id="loader"></div>
        </div>
    )
}

export default Loading
